import { CACHE_TAG_ACCOUNTS_VERSION_LIST, CACHE_TAG_ADDRESS_VERSION_LIST } from 'api/cacheTagTypes'
import api from '../index'

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    updateBillingAddress: builder.mutation({
      query: ({ accountId, body }) => ({
        url: `/api/v1/core/accounts/${accountId}/billing-address`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (result, error, { accountId }) => {
        const tags = [{ type: CACHE_TAG_ACCOUNTS_VERSION_LIST, id: accountId }]
        if (result?.id) tags.push({ type: CACHE_TAG_ADDRESS_VERSION_LIST, id: result?.id })
        return tags
      },
    }),
  }),
})

export const { useUpdateBillingAddressMutation } = extendedApi
